import {Swiper, SwiperSlide} from 'swiper/react'
import {Autoplay, Navigation} from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import Link from 'next/link'
import ProductItem from '../Products/ProductItem'
import { useTranslation } from 'next-i18next'
import NewProductItem from '../Products/NewProductItem'
import useUserPreferences from '@/hooks/useUserPreferences'
interface Props {
  personalized_notebooks: any
}

export default function PersonalizedNotebooks({personalized_notebooks}: Props) {
  const {t} = useTranslation('common');
  const preferences = useUserPreferences();
  const country = preferences?.countryCode || 'IL';
  // console.log('personalized notebooks:', personalized_notebooks);
  return (
    <div className={`featured mt-24 ${country === 'IL' ? 'container-fluid' : 'hidden'}`} id="notebooks">
      <h1 className="text-success text-center font-bold text-3xl">
        {t('personalizedNotebooks')}
      </h1>
      {/*
       *<div className="books-list mt-2 md:grid md:grid-cols-2 lg:grid-cols-4 md:gap-4 lg:gap-6">
       */}
      <div className="books-list mt-2 ">
        <Swiper
          autoplay={{delay: 3000}}
          spaceBetween={10}
          modules={[Navigation, Autoplay]}
          navigation={true}
          breakpoints={{
            // when window width is >= 640px
            640: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            // when window width is >= 768px
            768: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            960: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1366: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          }}>
          {personalized_notebooks?.map((product: any, idx: number) => {
            return (
              <SwiperSlide key={idx}>
                <NewProductItem key={product.id} product={product} name="" gender="" />
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
      <div className="browse-btn text-center">
        <Link
          href="/products?product_type=2"
          className="inline-block mt-6 border-2 border-primary text-primary text-center font-semibold rounded-lg px-12 py-[.9rem]">
          {t('viewMore')}
        </Link>
      </div>
    </div>
  )
}
